import { useQuickPrice } from './hooks/useQuickPrice.js';
import { usePostHeight } from './hooks/usePostHeight.js';
import { LoanColumn, PropertyColumn, TopRow } from './components/ScenarioForm.js';
import { ResultsPanelPolly } from './components/ResultsPanelPolly.js';
import { SkyCloudPuff } from './components/puffs.jsx';
import { getOrgConfig } from '../../utils/organizationConfigUtil.js';
import { LOGIN_VARIANTS } from '../../config/organizations.js';
import { cx } from 'class-variance-authority';

import './styles.css';
import './styles-sky.css';

export default function QuickPriceFormNew({ isCorrespondent = false }) {
    const orgConfig = getOrgConfig();
    const isSkyTPO = orgConfig.id === 'SkyTPO';

    const { form, scenario, resultPolly, isPollyPricing, update } = useQuickPrice(isCorrespondent);
    usePostHeight(orgConfig.id === LOGIN_VARIANTS.CHAMPSTPO);
    const limits = resultPolly?.status === 'priced' ? resultPolly.limits : null;

    return (
        <div className="eva_wrapper_qp">
            <div className="quickprice_top">
                {isSkyTPO && <SkyCloudPuff />}
                <TopRow form={form} scenario={scenario} update={update} />
            </div>

            <div className="quickprice_content clearfix">
                <div className={cx(isSkyTPO && "grid")}>
                    <LoanColumn form={form} scenario={scenario} update={update} limits={limits} />
                    <PropertyColumn form={form} scenario={scenario} update={update} />
                    <ResultsPanelPolly
                        result={resultPolly}
                        isPricing={isPollyPricing}
                        form={form}
                        scenario={scenario}
                    />
                </div>
            </div>
        </div>
    );
}
